import { combineReducers } from 'redux';

import profile from './profile';
import loginState from './loginState';
import unsubscription from './unsubscription';
import unsubscribeState from './unsubscribeState';
import unsubscribeErrorCount from './unsubscribeErrorCount';
import vipSubscription from './vipSubscription';
import packageSubscriptions from './packageSubscriptions';
import unfulfilledsSubscription from './unfulfilledsSubscription';
import productSubscriptionsFetchState from './productSubscriptionsFetchState';
import readExpireSoonPackageSubscriptions from './readExpireSoonPackageSubscriptions';
import favoriteDramas from './favoriteDramas';
import favoriteDramasFetchState from './favoriteDramasFetchState';
import watchHistory from './watchHistory';
import watchHistoryFetchState from './watchHistoryFetchState';
import policies from './policies';

export default combineReducers({
  profile,
  loginState,
  unsubscription,
  unsubscribeState,
  unsubscribeErrorCount,
  vipSubscription,
  packageSubscriptions,
  unfulfilledsSubscription,
  productSubscriptionsFetchState,
  readExpireSoonPackageSubscriptions,
  favoriteDramas,
  favoriteDramasFetchState,
  watchHistory,
  watchHistoryFetchState,
  policies,
});
